import React from 'react';
import { Chip } from '@mui/material';
import { DesktopWindowsIcon } from '@/shared/ui/display/EmojiIcon';
import { fontSize, typography } from '@/shared/theme';

/** 클라이언트 ID → 표시 라벨 매핑 */
const CLIENT_LABELS: Record<string, string> = {
  'mv-agent-desktop-1.0.0-arm64': '데스크톱',
};

export interface ClientChipProps {
  clientId: string;
}

export function ClientChip({ clientId }: ClientChipProps) {
  const label = CLIENT_LABELS[clientId] ?? clientId;

  return (
    <Chip
      icon={<DesktopWindowsIcon sx={{ fontSize: 14 }} />}
      label={label}
      size="small"
      variant="outlined"
      sx={{
        height: 22,
        fontSize: fontSize.sm,
        fontWeight: typography.cell.fontWeight,
        '& .MuiChip-icon': {
          marginLeft: 0.5,
          marginRight: 0,
        },
      }}
    />
  );
}
